/**
 * menuApp Alpine component — reads window._webMenuConfig.
 * Persists activeTab via WebMenuStorage (same backend as cart).
 */
document.addEventListener('alpine:init', () => {
  Alpine.data('menuApp', () => {
    const cfg = window._webMenuConfig || {};
    const categories = cfg.categories || [];
    const pageId = cfg.pageId || 'default';
    const storage = window.WebMenuStorage.create(pageId);
    const tabKey = cfg.activeTabStorageKey || ('active-tab-' + pageId);

    function loadActiveTab() {
      const saved = storage.get(tabKey);
      if (saved && categories.some(c => c.id === saved)) return saved;
      return categories[0]?.id || 'mains';
    }

    const items = (cfg.items || []).map(item => ({
      ...item,
      category: item.category || item.categoryId,
      image: item.image || item.imageUrl
    }));

    return {
      activeTab: loadActiveTab(),
      selectedItem: null,
      removedExpanded: false,
      menuItems: items,

      init() {
        this.$watch('activeTab', (id) => {
          if (id && categories.some(c => c.id === id)) {
            storage.set(tabKey, id);
          }
        });
      },

      getItemsByCategory(category) {
        return this.menuItems.filter(i => (i.category || i.categoryId) === category);
      },

      openItemModal(item) { this.selectedItem = item; },

      addToCart(item) { Alpine.store('cart').add(item); },
      removeFromCart(index) { Alpine.store('cart').remove(index); },
      undoRemoved(index) { Alpine.store('cart').restoreRemoved(index); },
      updateQuantity(index, delta) { Alpine.store('cart').updateQuantity(index, delta); },
      getItemQuantity(name) { return Alpine.store('cart').getItemQuantity(name); },
      updateQuantityByName(name, delta) { Alpine.store('cart').updateQuantityByName(name, delta); },

      adjustItemQuantity(item, delta) {
        const cart = Alpine.store('cart');
        const qty = cart.getItemQuantity(item.name);
        if (delta > 0) {
          if (qty === 0) cart.add(item);
          else cart.updateQuantityByName(item.name, delta);
        } else if (qty > 0) {
          cart.updateQuantityByName(item.name, delta);
        }
      }
    };
  });
});
